<template>
  <div>
    <ad-drawer
      :showBtn="true"
      :visible.sync="show"
      :configDraw="configDraw"
      @sure="sure"
      @close="cancel"
    >
      <el-tabs v-model="activeName">
        <el-tab-pane
          label="个人素材库"
          name="1"
          ><PersonalMaterial
            ref="personalMaterial"
            v-if="show && activeName == '1'"
            :saveAdFileParam="saveAdFileParam"
            platform="google"
            is-open=""
            :chooseList="chooseIdList"
            :uploadTypes="uploadTypes === 'IMAGE' ? 'img' : 'video'"
            :pageObj="pageObj"
            :showSelectAll="type == 'logo' && limit > 1"
            :enableAuditStatus="uploadTypes !== 'IMAGE'"
            @choose="selectMaterial"
            @changeTotal="changeTotal" />
          <div class="text-right h-4">
            <el-pagination
              small
              layout="prev, pager, next"
              :total="total"
              :page-size="pageObj.pageSize"
              @current-change="handleCurrentChange"
              :current-page.sync="pageObj.page"
            >
            </el-pagination></div
        ></el-tab-pane>
        <el-tab-pane
          label="广告素材库"
          name="2"
        >
          <AdMaterialsChild
            v-if="show && activeName == '2'"
            ref="adx"
            @chooseAdMaterial="chooseAdMaterial"
            v-bind="{ ...adMaterialParams, platform: '' }"
            :mediaType="uploadTypes"
            :mediaTypeDisabled="true"
        /></el-tab-pane>
        <el-tab-pane
          label="官方素材库"
          name="3"
          v-if="uploadTypes == 'IMAGE'"
        >
          <ImageLibrary
            v-if="show && activeName == '3'"
            :accountId="currentAccount.id"
            :chooseList="chooseIdList"
            @choose="selectMaterial"
        /></el-tab-pane>
      </el-tabs>
    </ad-drawer>
  </div>
</template>
<script>
import { adDrawer, AdMaterialsChild } from '@adCommonComponent';
import PersonalMaterial from '@/views/adManagement/createAd/components/adsComponents/PersonalMaterial.vue';
import ImageLibrary from '@/views/google/create/components/creatives/ImageLibrary/index.vue';
export default {
  components: { adDrawer, PersonalMaterial, AdMaterialsChild, ImageLibrary },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    saveAdFileParam: {
      type: Object,
      default: () => {},
    },
    uploadTypes: {
      type: String,
      default: 'IMAGE',
    },
    //广告素材库参数
    adMaterialParams: {
      type: Object,
      default: () => ({}),
    },
    // 账户
    currentAccount: {
      type: Object,
      default: () => ({}),
    },
    limit: {
      type: Number,
      default: 10,
    },
    type: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      configDraw: {
        title: '素材库',
        size: '1300px',
        'append-to-body': true,
      },
      chooseIdList: [],
      chooseImgList: [],
      total: 0,
      pageObj: {
        page: 0,
        pageSize: 30,
      },
      activeName: '1',
    };
  },
  computed: {},
  methods: {
    selectMaterial(id, img) {
      console.log(id, img);
      if (this.limit == 1) {
        this.chooseIdList = [id];
        this.chooseImgList = [img];
        return;
      }
      if (this.chooseIdList.includes(id)) {
        this.chooseIdList.splice(
          this.chooseIdList.findIndex((v) => v == id),
          1,
        );
        this.chooseImgList.splice(
          this.chooseImgList.findIndex((v) => v.id == id),
          1,
        );
      } else {
        this.chooseIdList.push(id);
        this.chooseImgList.push(img);
      }
    },
    // 获取广告素材库
    chooseAdMaterial(v) {
      let list = v.map((m) => {
        return {
          ...m,
          md5_code: m.hashcode,
        };
      });
      this.chooseImgList = this.chooseImgList.concat(list);
    },
    // 获取素材总数
    changeTotal(total) {
      this.total = total;
    },
    // 点击分页
    handleCurrentChange(v) {
      this.pageObj.page = v;
      this.$refs.personalMaterial.getList();
    },
    closeDrawer() {
      this.$emit('update:show', false);
    },
    cancel() {
      this.chooseIdList = [];
      this.chooseImgList = [];
      (this.pageObj = {
        page: 0,
        pageSize: 30,
      }),
        this.closeDrawer();
    },
    async sure() {
      if (this.activeName == 2) {
        await this.$refs.adx.checkAndUpload();
      }
      console.log(this.chooseImgList);
      if (!this.chooseImgList.length) {
        this.$message.warning('请先选择素材');
        return;
      }

      // 如果是视频类型且来自个人素材库，批量提交未检测的视频
      if (this.uploadTypes !== 'IMAGE' && this.activeName == '1') {
        // 过滤出视频类型的素材
        const videoList = this.chooseImgList.filter((item) => item.type === '2');
        if (videoList.length) {
          try {
            await this.$refs.personalMaterial.batchSubmitVideoRiskMethod(videoList, {
              auditApiType: 'GIIKIN',
              platform: 'google',
            });
          } catch (error) {
            this.$message.error('提交素材检测失败，请重试');
            return;
          }
        }
      }

      this.$emit('getSelectList', this.chooseImgList);
      this.cancel();
    },
  },
  watch: {},
};
</script>
